document.addEventListener("DOMContentLoaded", function () {
  let activeImage = 1;
  let isOpen = false;
  const section = document.querySelector(".section__about-product");
  const images = section.querySelectorAll(".about-product__image");
  const pinsDesktop = section.querySelectorAll(".pin--desktop");
  const pinsMobile = section.querySelectorAll(".pin--mobile");
  const pinsContentMobile = document.querySelectorAll(".pin__content--mobile");
  const pinsMobileClose = document.querySelectorAll(".pin__content__close");
  const navigationDots = section.querySelectorAll(".navigation__dot");
  const fullPageShadow = document.querySelector(".fullpage-shadow");

  const closeAll = () => {
    isOpen = false;
    fullPageShadow.classList.remove("open");
    pinsMobile.forEach((pin) => pin.classList.remove("active"));
    pinsContentMobile.forEach((content) => content.classList.remove("open"));
    pinsDesktop.forEach((pin) => pin.classList.remove("active"));
  };

  document.addEventListener("keyup", (event) => {
    if (isOpen && event.key === "Escape") {
      closeAll();
    }
  });

  window.addEventListener("click", (event) => {
    if (isOpen && !event.target.closest(".pin")) {
      closeAll();
    }
  });

  const showActiveImage = () => {
    images.forEach((image) => {
      if (image.dataset.index === activeImage.toString()) {
        image.classList.remove("hidden");
      } else {
        image.classList.add("hidden");
      }
    });
    pinsDesktop.forEach((pin) => {
      pin.classList.remove("active");
      if (pin.dataset.index === activeImage.toString()) {
        pin.classList.remove("hidden");
      } else {
        pin.classList.add("hidden");
      }
    });

    pinsMobile.forEach((pin) => {
      pin.classList.remove("active");
      if (pin.dataset.index === activeImage.toString()) {
        isOpen = true;
        pin.classList.remove("hidden");
      } else {
        pin.classList.add("hidden");
      }
    });
    navigationDots.forEach((dot) => {
      if (dot.dataset.index === activeImage.toString()) {
        isOpen = true;
        dot.classList.add("active");
      } else {
        dot.classList.remove("active");
      }
    });
  };

  navigationDots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      activeImage = index + 1;
      showActiveImage();
    });
  });

  pinsDesktop.forEach((pin) => {
    pin.addEventListener("mouseenter", () => {
      pinsDesktop.forEach((pin) => pin.classList.remove("active"));
      isOpen = true;
      pin.classList.add("active");
    });

    pin.addEventListener("mouseleave", () => {
      isOpen = false;
      pin.classList.remove("active");
    });
  });

  pinsMobileClose.forEach((close) => {
    close.addEventListener("click", () => {
      fullPageShadow.classList.remove("open");
      pinsMobile.forEach((pin) => pin.classList.remove("active"));
      pinsContentMobile.forEach((content) => content.classList.remove("open"));
    });
  });

  pinsMobile.forEach((pin) => {
    pin.addEventListener("click", () => {
      const isActive = pin.classList.contains("active");
      const index = pin.dataset.index;
      const pinIndex = pin.dataset.pinindex;
      const mobileContent = Array.from(pinsContentMobile).find(
        (content) =>
          content.dataset.index === index &&
          content.dataset.pinindex === pinIndex
      );
      pinsMobile.forEach((pin) => pin.classList.remove("active"));
      if (isActive) {
        isOpen = false;
        fullPageShadow.classList.remove("open");
        pin.classList.remove("active");
        mobileContent.classList.remove("open");
      } else {
        isOpen = true;
        fullPageShadow.classList.add("open");
        pin.classList.add("active");
        mobileContent.classList.add("open");
      }
    });
  });

  showActiveImage();
});
